import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Hero from '../components/Hero';
import MyObservations from '../components/MyObservations';
import LatestVideos from '../components/LatestVideos';
import About from '../components/About';
import Contact from '../components/Contact';
import { useReveal } from '../hooks/useReveal';

function HomePage() {
  const { state } = useLocation();
  const navigate = useNavigate();

  useReveal();

  useEffect(() => {
    if (state?.scrollTo) {
      const element = document.getElementById(state.scrollTo);
      if (element) {
        requestAnimationFrame(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        });
      }
      navigate('.', { replace: true, state: {} });
    }
  }, [state, navigate]);

  return (
    <>
      <Hero />
      <MyObservations />
      <LatestVideos />
      <About />
      <Contact />
    </>
  );
}

export default HomePage;
